// @ts-check

import { codedJoinAnd, showError, showWarning } from "../../core/utils.js";

const ruleName = "no-empty-images";
export const name = "stichting-crow/linter-rules/no-empty-images";

/**
 * Checks if no images aren't loaded.
 *
 * @param {Conf} conf
 */
export function run(conf) {
  if (!conf.lint?.[ruleName]) {
    return;
  }

  const logger = conf.lint[ruleName] === "error" ? showError : showWarning;

  const images = document.querySelectorAll("img");
  const offendingElements = [...images].filter(
    node => node.complete && node.naturalHeight == 0
  );
  if (!offendingElements.length) return;
  const offendingMembers = offendingElements.map(node => node.src);

  const imgSources = codedJoinAnd(offendingMembers, { quotes: true });

  const msg = `Image could not be loaded (height: 0 px)`;
  const hint = `Check the resource URLs ${imgSources}`;
  logger(msg, name, { elements: offendingElements, hint: hint });
}
